import {
    Box,
    Button,
    Chip,
    Divider,
    Grid,
    Tab,
    Tabs,
    Tooltip,
    Typography,
    Pagination,
    IconButton,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    CircularProgress,
    Select,
    MenuItem,
} from '@mui/material';
import dayjs from 'dayjs';
import { common } from '@mui/material/colors';
import BaseDataGrid from 'common/components/base-data-grid';
import { GridColDef } from '@mui/x-data-grid';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MailIcon from '@mui/icons-material/Mail';
import RefreshIcon from '@mui/icons-material/Refresh';
import React from 'react';
import { ReactComponent as CopyIcon } from 'assets/images/icons/question-design/copy-question.svg';
import { CampaignContainer } from '../../campaign-overview/campaign-container';
import BaseTextField from 'common/components/base-text-field';
import FormProvider from 'common/components/form-provider';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { surveyFreeSchema } from 'common/schema';
import { toast } from 'react-toastify';
import { ReactComponent as DownloadIcon } from 'assets/images/icons/campaign-data-collection/qr-download.svg';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { createStyleSheet } from 'utils/helpers';
import CampaignModalCopy from '../../campaign/components/campaign-modal-copy';
import ModalConfirm from 'common/components/modal-confirm';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { updateStatusCampaign, copyCampaign } from 'services/campaign.service';
import { setCampaign } from 'slices/campaignsSlice';
import { campaignsResponseFormatter } from 'utils/campaign_helpers';
import { useTranslation } from 'react-i18next';
import { handleError } from 'utils/helpers';
import { useNavigate } from 'react-router-dom';
import CampaignConstants from 'pages/admin/campaign/constants';
import DataCollectConstants from '../constants';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { QRCodeCanvas } from 'qrcode.react';
import { colors } from 'common/constants';
import { ReactComponent as TotalDataIcon } from 'assets/images/icons/campaign-data-analytics/tổng dữ liệu thu thập.svg';
import { ReactComponent as EligibleIcon } from 'assets/images/icons/campaign-data-analytics/đủ điều kiện.svg';
import { ReactComponent as DataCollectedForAFeeIcon } from 'assets/images/icons/campaign-data-analytics/dữ liệu thu thập có phí.svg';
import { ReactComponent as TotalNumberOfParticipantsIcon } from 'assets/images/icons/campaign-data-analytics/tổng số người tham gia.svg';
import DialogAnswerModeration from './dialog-answer-moderation';
import { RootState } from 'plugins/store';
import CampaignExportButton from 'pages/admin/campaign/components/campaign-export-button';
import { savePDF } from '@progress/kendo-react-pdf';
import { listAnswerApprovals } from 'services/answerApproval.service';
import {
    IDataCollectSearchForm,
    IDataCollectSearchPayload,
    IAnswerApproval,
} from 'types/dataCollect';
import { setIsLoading } from 'slices/loadingSlice';
import SelectObject from './select-object';
import CampaignStatus from 'pages/admin/campaign/components/campaign-status';
import CustomPagination from 'pages/admin/campaign/components/custom-pagination';
import CampaignCheckBoxChecked from 'pages/admin/campaign/components/icons/campaign-check-box-checked';
import CampaignCheckBoxUnchecked from 'pages/admin/campaign/components/icons/campaign-check-box-uncheck';
import {
    listUniqLinks,
    downloadUniqLinkTemplate,
    importUniqLinks,
    exportUniqLinks,
    updateUniqLinkInSurvey,
    deleteUniqLinkInSurvey,
    sendReminderEmail,
    sendBatchReminderEmail,
    listSecretCodes,
    createSecretCodes,
} from 'services/uniqLink.service';
import { FORMAT } from 'common/constants';
import { IListUniqLinksPayload, IUniqLink } from 'types/uniq-link';
import BaseNumberInput from 'common/components/base-number-input';

const DOMAIN_FE = process.env.REACT_APP_FE_URL;

const SurveyActive: React.FC = () => {
    const [openModalCopy, setOpenModalCopy] = React.useState(false);
    const [openModalConfirm, setOpenModalConfirm] = React.useState(false);
    const [statusToConfirm, setStatusToConfirm] = React.useState('');
    const [modalConfirmTitle, setModalConfirmTitle] = React.useState('');
    const [modalConfirmContent, setModalConfirmContent] =
        React.useState<React.ReactNode>();
    const [tabActive, setTabActive] = React.useState(0);
    const [openModalCensor, setOpenModalCensor] = React.useState(false);
    const [listAnswerApproved, setListAnswerApproved] = React.useState<
        IAnswerApproval[]
    >([]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [listQuestions, setListQuestions] = React.useState<any[]>([]);
    const [answerApprove, setAnswerApprove] =
        React.useState<IAnswerApproval | null>(null);

    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const currentCampaign = useAppSelector(
        (state) => state.campaignState.campaign
    );

    const userInfo = useAppSelector((state: RootState) => state.user);
    const dataCollectSearchForm = useAppSelector(
        (state: RootState) => state.dataCollect.dataCollectSearchForm
    );
    const [answerInfo, setAnswerInfo] = React.useState<number[]>([]);
    const [paginationInfo, setPaginationInfo] = React.useState<{
        currentPage: number;
        totalPage: number;
        perPage: number;
        totalItems: number;
    }>({
        currentPage: 1,
        totalPage: 1,
        perPage: 20,
        totalItems: 0,
    });

    const [uniqLinks, setUniqLinksData] = React.useState<IUniqLink[]>([]);
    const [uniqLinksPaginationModel, setUniqLinksPaginationModel] =
        React.useState({
            page: 0,
            pageSize: 10,
        });
    const [uniqLinksRowCount, setUniqLinksRowCount] = React.useState(0);
    const [uploadingUniqLinks, setUploadingUniqLinks] = React.useState(false);
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    const [updatingUniqLink, setUpdatingUniqLink] = React.useState(false);
    const [selectedUniqLinkIds, setSelectedUniqLinkIds] = React.useState<
        number[]
    >([]);
    const [sendingBatchReminder, setSendingBatchReminder] =
        React.useState(false);
    const [loadingActionStates, setLoadingActionStates] = React.useState<
        Record<number, 'edit' | 'delete' | 'send' | null>
    >({});
    const [openEditUniqLinkModal, setOpenEditUniqLinkModal] =
        React.useState<boolean>(false);
    const [selectedUniqLink, setSelectedUniqLink] =
        React.useState<IUniqLink | null>(null);
    const [editFormData, setEditFormData] = React.useState({
        customer_id: '',
        email: '',
        phone: '',
    });
    const campaignId = currentCampaign?.id;
    const [uniqLinkStatistics, setUniqLinkStatistics] = React.useState<{
        total: number;
        not_answered: number;
        answered: number;
    }>({
        total: 0,
        not_answered: 0,
        answered: 0,
    });
    const [uniqLinkStatusFilter, setUniqLinkStatusFilter] = React.useState<
        'all' | 'answered' | 'not_answered'
    >('all');
    const [loadingUniqLinks, setLoadingUniqLinks] = React.useState(false);

    // States for Secret Once Codes
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    const [secretCodesData, setSecretCodesData] = React.useState<any[]>([]);
    const [secretCodesPaginationModel, setSecretCodesPaginationModel] =
        React.useState({
            page: 0,
            pageSize: 10,
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    const [secretCodesRowCount, setSecretCodesRowCount] =
        React.useState<number>(0);
    const [loadingSecretCodes, setLoadingSecretCodes] = React.useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    const [secretCodeStatistics, setSecretCodeStatistics] = React.useState<any>(
        {
            total: 0,
            not_answered: 0,
            answered: 0,
        }
    );
    const [secretCodeStatusFilter, setSecretCodeStatusFilter] = React.useState<
        'all' | 'answered' | 'not_answered'
    >('all');
    const [openCreateSecretCodeModal, setOpenCreateSecretCodeModal] =
        React.useState(false);
    const [createSecretCodeLoading, setCreateSecretCodeLoading] =
        React.useState(false);
    const [createSecretCodeForm, setCreateSecretCodeForm] = React.useState({
        quantity: '',
    });
    // Tạm ẩn cùng cột Hành động secret code — chưa có API xóa
    // const [loadingActionStatesSecretCode, setLoadingActionStatesSecretCode] =
    //     React.useState<Record<number, 'delete' | null>>({});

    // Helper function to transform raw API data to IUniqLink format
    const transformUniqLinksData = (
        rawData: {
            attributes: {
                id: number;
                customer_id: string;
                staff_id: number;
                email: string;
                phone: string;
                code: string;
                url_survey: string;
                is_answered: boolean;
                survey_id: number;
                answered_at: string | null;
                created_at: string;
                updated_at: string;
            };
        }[]
    ): IUniqLink[] => {
        return rawData.map(({ attributes }) => ({
            id: attributes.id,
            customer_id: attributes.customer_id,
            staff_id: attributes.staff_id,
            email: attributes.email,
            phone: attributes.phone,
            code: attributes.code,
            url_survey: attributes.url_survey,
            is_answered: attributes.is_answered,
            survey_id: attributes.survey_id,
            answered_at: attributes.answered_at,
            created_at: dayjs(attributes.created_at).format(FORMAT.date.DMY),
            updated_at: attributes.updated_at,
        }));
    };

    // Helper function to fetch and set uniq links data
    const fetchAndSetUniqLinksData = async (page = 0) => {
        if (!campaignId) return;

        try {
            setLoadingUniqLinks(true);
            const params: IListUniqLinksPayload = {
                survey_id: Number(campaignId),
                page: page + 1,
                status: uniqLinkStatusFilter,
            };
            const response = await listUniqLinks(params);
            const data = response?.user_unique_links || [];
            setUniqLinksData(transformUniqLinksData(data));
            setUniqLinksRowCount(response?.meta?.total_count || 0);

            const stats = response?.statistics;
            setUniqLinkStatistics({
                total: stats?.total || 0,
                answered: stats?.answered || 0,
                not_answered: stats?.not_answered || 0,
            });
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingUniqLinks(false);
        }
    };

    // Fetch Uniq Links data
    React.useEffect(() => {
        if (!currentCampaign?.is_unique_link) return;

        fetchAndSetUniqLinksData(uniqLinksPaginationModel.page);
    }, [uniqLinksPaginationModel, currentCampaign, uniqLinkStatusFilter]);

    // Helper function to fetch and set secret codes data
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const fetchAndSetSecretCodesData = async (page = 0) => {
        if (!campaignId) return;

        try {
            setLoadingSecretCodes(true);
            // TODO: Replace with actual API call when available
            // For now, using a mock response structure
            const params = {
                survey_id: Number(campaignId),
                page: page + 1,
                status: secretCodeStatusFilter,
            };
            const response = await listSecretCodes(params);
            console.log('Secret Codes response:', response);
            const data = response?.data?.secret_codes || [];
            setSecretCodesData(data);
            setSecretCodesRowCount(response?.data?.total_items || 0);
            const stats = response?.data?.statistics;
            setSecretCodeStatistics({
                total: stats?.total || 0,
                answered: stats?.answered || 0,
                not_answered: stats?.not_answered || 0,
            });
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingSecretCodes(false);
        }
    };

    // Fetch Secret Codes data
    React.useEffect(() => {
        if (currentCampaign?.secure_type !== 'secret_once') return;

        fetchAndSetSecretCodesData(secretCodesPaginationModel.page);
    }, [secretCodesPaginationModel, currentCampaign, secretCodeStatusFilter]);

    const handleChangeTabs = (
        event: React.SyntheticEvent,
        newValue: number
    ) => {
        setTabActive(newValue);
    };
    const isCampaignPublicWithCode =
        currentCampaign?.kind === 'public_with_code';
    const linkToPreview = React.useMemo(() => {
        let link = '';
        if (isCampaignPublicWithCode) {
            link = `${DOMAIN_FE}/survey/invite/${currentCampaign?.uuid}?surveyCode=${currentCampaign?.uuid}`;
        } else if (currentCampaign?.kind === 'page_logic') {
            link = `${DOMAIN_FE}/survey/page-logic/${currentCampaign?.uuid}?surveyCode=${currentCampaign?.uuid}`;
        } else {
            link = `${DOMAIN_FE}/survey/preview/${currentCampaign?.uuid}?surveyCode=${currentCampaign?.uuid}`;
        }

        const isSecretSurvey =
            currentCampaign?.secure_type === 'secret' ||
            currentCampaign?.secure_type === 'secret_once';
        if (isSecretSurvey) {
            link += `&isSecretSurvey=true`;
        }
        return link;
    }, [currentCampaign, isCampaignPublicWithCode]);

    const downloadQRCanvas = () => {
        const canvas = document.getElementById('qrCanvas') as HTMLCanvasElement;
        if (!canvas || !currentCampaign) return;

        const url = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.download = `qr_survey_${currentCampaign.id}.png`;
        link.href = url;
        link.click();
    };

    const methods = useForm({
        resolver: yupResolver(surveyFreeSchema),
        defaultValues: {
            url: linkToPreview,
            code: currentCampaign?.code || '',
            quantity: 0,
        },
    });

    const renderApprovalStatus = (status: string) => {
        let bgColor = '';
        let textColor = '';

        switch (status) {
            case 'Chưa duyệt':
                bgColor = '#FFEEE2';
                textColor = '#FF7916';
                break;
            case 'Đã duyệt':
                bgColor = '#EFFBFF';
                textColor = '#475EFB';
                break;
            case 'Từ chối':
                bgColor = 'var(--color-primary-light-40)';
                textColor = 'var(--color-primary)';
                break;
        }

        return (
            <Chip
                label={status}
                sx={{
                    borderRadius: 'unset',
                    fontSize: '12px',
                    backgroundColor: bgColor,
                    color: textColor,
                    border: 'unset',
                }}
            />
        );
    };

    const campaignStatusTitle = React.useMemo(() => {
        if (!currentCampaign) return '';
        switch (currentCampaign.status_client) {
            case CampaignConstants.status.CLIENT_DRAFT:
                return 'chưa kích hoạt';
            case CampaignConstants.status.CLIENT_INPROGRESS:
            case CampaignConstants.status.TO_DO:
                return 'đã kích hoạt';
            case CampaignConstants.status.CLIENT_COMPLETED:
                return 'đã hoàn thành';
            case CampaignConstants.status.CLIENT_CLOSED:
                return 'đã đóng';
            default:
                return '';
        }
    }, [currentCampaign]);

    const campaignStatusTitleDescription = React.useMemo(() => {
        if (!currentCampaign) return '';
        switch (currentCampaign.status_client) {
            case CampaignConstants.status.CLIENT_DRAFT:
                return 'chưa kích hoạt';
            case CampaignConstants.status.CLIENT_INPROGRESS:
            case CampaignConstants.status.TO_DO:
                return 'đã được chạy và đang nhận kết quả';
            case CampaignConstants.status.CLIENT_COMPLETED:
                return 'đã hoàn thành và ngừng nhận kết quả';
            case CampaignConstants.status.CLIENT_CLOSED:
                return 'đã đóng và ngừng nhận kết quả';
            default:
                return '';
        }
    }, [currentCampaign]);

    const handleUpdateStatus = async () => {
        try {
            if (!currentCampaign) return;
            const response = await updateStatusCampaign(
                currentCampaign.id,
                statusToConfirm
            );
            if (response.success) {
                toast.success(response.message);
                dispatch(
                    setCampaign(campaignsResponseFormatter(response.data, t))
                );
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    };

    const onConfirmCopyCampaign = async () => {
        try {
            if (!currentCampaign) return;
            setOpenModalCopy(false);
            const response = await copyCampaign(currentCampaign?.id);
            if (!response.success) {
                toast.error(response.message);
                return;
            }
            toast.success(response.message);
            navigate('/admin/campaign');
        } catch (error) {
            handleError(error);
        }
    };

    const handleCopyUrl = () => {
        toast.success('Đã sao chép đường dẫn');
    };

    const container = React.useRef(null);
    const exportPDFWithMethod = () => {
        const element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 40,
            fileName: `Thu thập dữ liệu - Phản hồi ${currentCampaign?.campaign}`,
        });
    };

    React.useEffect(() => {
        if (!currentCampaign) return;
        if (
            currentCampaign?.status_client ===
            CampaignConstants.status.CLIENT_DRAFT
        ) {
            navigate(`/admin/campaign/data-collect/${currentCampaign.id}`);
        }
    }, [currentCampaign, navigate]);

    React.useEffect(() => {
        methods.reset({
            url: linkToPreview,
            code: currentCampaign?.code || '',
            quantity: 0,
        });
    }, [linkToPreview, currentCampaign, methods]);

    const transformDataCollectSearchParams = (
        formState: IDataCollectSearchForm
    ): IDataCollectSearchPayload => {
        const params = { ...formState };
        if (formState.device?.includes(DataCollectConstants.device.ALL)) {
            params.device = [];
        }
        if (formState.status?.includes(DataCollectConstants.status.ALL)) {
            params.status = [];
        }
        return {
            page: 1,
            q: {
                status_in: params.status?.join(','),
                device_kind_in: params.device?.join(','),
                start_date: params.startDate ?? null,
                end_date: params.endDate ?? null,
            },
        };
    };

    const fetchListAnswerApprovals = React.useCallback(
        async (page = 1) => {
            if (!currentCampaign) return;
            try {
                dispatch(setIsLoading(true));
                const params = transformDataCollectSearchParams(
                    dataCollectSearchForm
                );
                params['page'] = page;

                const response = await listAnswerApprovals(
                    currentCampaign.id,
                    params
                );
                if (response.success) {
                    setListQuestions(
                        response.data.questions.map(
                            (item: any) => item.attributes // eslint-disable-line @typescript-eslint/no-explicit-any
                        )
                    );
                    setAnswerInfo([
                        response.data.total_answered,
                        response.data.total_answer_approved,
                        response.data.total_answer_paid,
                        response.data.total_user_answered,
                    ]);
                    setPaginationInfo({
                        currentPage: response.data.current_page,
                        totalPage: response.data.total_page,
                        perPage: response.data.per_page,
                        totalItems: response.data.total_items,
                    });
                    setListAnswerApproved(
                        response.data.answer_approvals.map(
                            (item: any) => item.attributes // eslint-disable-line @typescript-eslint/no-explicit-any
                        )
                    );
                    dispatch(setIsLoading(false));
                } else {
                    dispatch(setIsLoading(false));
                    toast.error(response.message);
                }
            } catch (error) {
                dispatch(setIsLoading(false));
                handleError(error);
            }
        },
        [currentCampaign, dataCollectSearchForm, dispatch]
    );

    React.useEffect(() => {
        if (tabActive === 1) {
            fetchListAnswerApprovals();
        }
    }, [tabActive, fetchListAnswerApprovals]);

    const handleChangePage = (
        event: React.ChangeEvent<unknown>,
        value: number
    ) => {
        fetchListAnswerApprovals(value);
    };

    const changeAnswerApprovedStatus = (answerId: string, status: string) => {
        if (status === t('page.dataCollect.status.approved')) {
            setAnswerInfo((prev) => {
                return [prev[0], prev[1] + 1, prev[2], prev[3]];
            });
        }
        setListAnswerApproved((prev) =>
            prev.map((item) => {
                if (item.id === answerId) {
                    return {
                        ...item,
                        status,
                    };
                }
                return item;
            })
        );
    };

    return (
        <CampaignContainer>
            {userInfo.attributes.role !== 'client' && (
                <Box sx={{ width: '20%', mx: 'auto' }} mb={3}>
                    <Tabs
                        TabIndicatorProps={{
                            style: {
                                display: 'none',
                            },
                        }}
                        value={tabActive}
                        onChange={handleChangeTabs}
                        aria-label="wrapped label tabs example"
                        centered
                        sx={{
                            border: `1px solid ${colors.main}`,
                            backgroundColor: (theme) =>
                                theme.palette.common.white,
                            borderRadius: '50px',
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: '700',
                                color: colors.main,
                            },
                            '& .Mui-selected': {
                                color: `${common.white} !important`,
                                fontWeight: '700',
                                backgroundColor: colors.main,
                                borderRadius: '50px',
                            },
                            '& .MuiTabs-indicator': {
                                display: 'none',
                            },
                        }}
                    >
                        <Tab value={0} sx={{ flex: 1 }} label="Tổng kết" />
                        <Tab value={1} sx={{ flex: 1 }} label="Phản hồi" />
                    </Tabs>
                </Box>
            )}

            <Grid container spacing={4}>
                {!currentCampaign?.is_unique_link && (
                    <Grid item xs={12} md={3}>
                        <Box
                            sx={{
                                borderRadius: '15px',
                                height: '100%',
                                overflow: 'auto',
                                backgroundColor: common.white,
                                padding: 3,
                                textAlign: 'center',
                            }}
                        >
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '26px',
                                    fontWeight: 700,
                                    lineHeight: '31.47px',
                                    marginBottom: '13px',
                                }}
                            >
                                Chia sẻ khảo sát của bạn
                            </Typography>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '18px',
                                    fontWeight: 400,
                                    lineHeight: '21.78px',
                                    marginBottom: '20px',
                                }}
                            >
                                Sao chép đường dẫn và gửi cho bạn bè của bạn
                            </Typography>
                            <Box>
                                <FormProvider methods={methods}>
                                    <BaseTextField
                                        name="url"
                                        sx={{
                                            marginBottom: '27px',
                                            '& .MuiInputBase-root': {
                                                borderRadius: '50px',
                                                height: '60px',
                                            },
                                        }}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <CopyToClipboard
                                                    text={linkToPreview}
                                                    onCopy={handleCopyUrl}
                                                >
                                                    <CopyIcon
                                                        style={{
                                                            cursor: 'pointer',
                                                            width: '20px',
                                                        }}
                                                    />
                                                </CopyToClipboard>
                                            ),
                                        }}
                                    />
                                </FormProvider>
                            </Box>
                            {currentCampaign?.secure_type === 'secret' && (
                                <Box>
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontSize: '18px',
                                            fontWeight: 400,
                                            lineHeight: '21.78px',
                                            marginBottom: '20px',
                                        }}
                                    >
                                        Sao chép mã tham dự và gửi cho bạn bè
                                        của bạn
                                    </Typography>

                                    <Box>
                                        <FormProvider methods={methods}>
                                            <BaseTextField
                                                name="code"
                                                sx={{
                                                    marginBottom: '27px',
                                                    '& .MuiInputBase-root': {
                                                        borderRadius: '50px',
                                                        height: '60px',
                                                    },
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                        <CopyToClipboard
                                                            text={
                                                                currentCampaign?.code ||
                                                                ''
                                                            }
                                                            onCopy={() => {
                                                                toast.success(
                                                                    'Đã sao chép mã tham dự'
                                                                );
                                                            }}
                                                        >
                                                            <CopyIcon
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    width: '20px',
                                                                }}
                                                            />
                                                        </CopyToClipboard>
                                                    ),
                                                }}
                                            />
                                        </FormProvider>
                                    </Box>
                                </Box>
                            )}
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '26px',
                                    fontWeight: 700,
                                    lineHeight: '31.47px',
                                    marginBottom: '13px',
                                }}
                            >
                                QR code của khảo sát
                            </Typography>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '18px',
                                    fontWeight: 400,
                                    lineHeight: '21.78px',
                                    marginBottom: '16px',
                                }}
                            >
                                Tải QR code của khảo sát về, in và dán ở các địa
                                điểm phù hợp
                            </Typography>
                            <Box>
                                <QRCodeCanvas
                                    value={linkToPreview}
                                    id="qrCanvas"
                                    size={256}
                                />
                            </Box>
                            <Box>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<DownloadIcon />}
                                    sx={{
                                        borderRadius: '50px',
                                        height: '50px',
                                        width: '141px',
                                        marginTop: '20px',
                                        fontSize: '20px',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                        lineHeight: '24.2px',
                                    }}
                                    onClick={downloadQRCanvas}
                                >
                                    Tải về
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                )}
                {tabActive === 0 && (
                    <Grid
                        item
                        xs={12}
                        md={!currentCampaign?.is_unique_link ? 9 : 12}
                    >
                        <Box
                            sx={{
                                borderRadius: '15px',
                                height: '100%',
                                overflow: 'auto',
                                backgroundColor: common.white,
                                padding: '32px 85px',
                            }}
                        >
                            <Box
                                sx={{
                                    textAlign: 'center',
                                    width: '100%',
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 2,
                                        marginBottom: '28.19px',
                                    }}
                                >
                                    <Box sx={{ flex: 1 }}></Box>

                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '30px',
                                                lineHeight: '36.31px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {currentCampaign?.campaignKind}
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <CampaignStatus
                                            status={
                                                currentCampaign?.status_client as string
                                            }
                                        />
                                    </Box>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    textAlign: 'center',
                                }}
                            >
                                <CheckCircleIcon
                                    sx={{
                                        fontSize: 80,
                                        color: 'var(--color-primary)',
                                        marginBottom: '24.25px',
                                    }}
                                />
                            </Box>
                            {currentCampaign && (
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '30px',
                                        lineHeight: '36.31px',
                                        marginBottom: '25px',
                                        textAlign: 'center',
                                    }}
                                >
                                    “{currentCampaign?.campaign}”{' '}
                                    {campaignStatusTitle}
                                </Typography>
                            )}

                            <Typography
                                variant="body1"
                                sx={{
                                    fontWeight: 400,
                                    fontSize: '22px',
                                    lineHeight: '26.63px',
                                    marginBottom: '46px',
                                    textAlign: 'center',
                                }}
                            >
                                Khảo sát này {campaignStatusTitleDescription}.
                                Bạn không thể thêm hoặc xóa câu hỏi và các câu
                                trả lời! <br />
                                Nếu bạn cần thay đổi nội dung của khảo sát, bạn
                                hãy nhân bản khảo sát này và thực hiện chỉnh sửa
                                trên khảo sát mới.
                            </Typography>
                            {currentCampaign && (
                                <>
                                    <Box>
                                        <Button
                                            disableTouchRipple
                                            variant="contained"
                                            sx={{
                                                ...styles.btn,
                                                marginBottom: '39px',
                                                textAlign: 'left',
                                                backgroundColor: common.white,
                                                color: '#000000B2',
                                                fontWeight: 400,
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                boxShadow: 'unset',
                                                border: '1px solid #0000004D',
                                                ':hover': {
                                                    backgroundColor:
                                                        common.white,
                                                    boxShadow: 'unset',
                                                },
                                            }}
                                            onClick={() =>
                                                setOpenModalCopy(true)
                                            }
                                        >
                                            <CopyIcon
                                                style={{
                                                    cursor: 'pointer',
                                                    width: '22px',
                                                    marginRight: '8px',
                                                }}
                                            />
                                            Nhân bản khảo sát này
                                        </Button>
                                    </Box>
                                    {currentCampaign.campaignKind ===
                                        'Dịch vụ khảo sát' && (
                                        <SelectObject
                                            tabIndex={0}
                                            setActiveStep={() => {
                                                return;
                                            }}
                                            sizeModifier={0.65}
                                            disableForm={true}
                                        />
                                    )}
                                    {currentCampaign.status_client !==
                                        CampaignConstants.status
                                            .CLIENT_COMPLETED && (
                                        <>
                                            <Button
                                                onClick={() => {
                                                    setOpenModalConfirm(true);
                                                    setStatusToConfirm(
                                                        currentCampaign.status_client ===
                                                            CampaignConstants
                                                                .status
                                                                .CLIENT_CLOSED
                                                            ? currentCampaign.inPublicTime
                                                                ? CampaignConstants
                                                                      .status
                                                                      .CLIENT_INPROGRESS
                                                                : CampaignConstants
                                                                      .status
                                                                      .TO_DO
                                                            : CampaignConstants
                                                                  .status
                                                                  .CLIENT_CLOSED
                                                    );
                                                    setModalConfirmTitle(
                                                        currentCampaign.status_client ===
                                                            CampaignConstants
                                                                .status
                                                                .CLIENT_CLOSED
                                                            ? 'Xác nhận mở lại khảo sát'
                                                            : 'Xác nhận đóng khảo sát'
                                                    );
                                                    setModalConfirmContent(
                                                        currentCampaign.status_client ===
                                                            CampaignConstants
                                                                .status
                                                                .CLIENT_CLOSED ? (
                                                            <Box>
                                                                Bạn có chắc muốn
                                                                mở lại khảo sát{' '}
                                                                <strong>
                                                                    “
                                                                    {currentCampaign?.campaign ||
                                                                        ''}
                                                                    ”
                                                                </strong>{' '}
                                                                này không?
                                                                <br />
                                                                Lưu ý: Khi mở
                                                                lại khảo sát này
                                                                sẽ tiếp tục thu
                                                                thập dữ liệu.
                                                            </Box>
                                                        ) : (
                                                            <Box>
                                                                Bạn có chắc muốn
                                                                đóng khảo sát{' '}
                                                                <strong>
                                                                    “
                                                                    {currentCampaign?.campaign ||
                                                                        ''}
                                                                    ”
                                                                </strong>{' '}
                                                                này không?
                                                                <br />
                                                                Lưu ý: Khi đóng
                                                                khảo sát này sẽ
                                                                dừng thu thập dữ
                                                                liệu.
                                                            </Box>
                                                        )
                                                    );
                                                }}
                                                disableTouchRipple
                                                variant="contained"
                                                sx={{
                                                    ...styles.btn,
                                                    marginBottom: '39px',
                                                }}
                                            >
                                                {currentCampaign.status_client ===
                                                CampaignConstants.status
                                                    .CLIENT_CLOSED
                                                    ? 'Mở lại khảo sát'
                                                    : 'Đóng khảo sát'}
                                            </Button>
                                            <Button
                                                disableTouchRipple
                                                variant="contained"
                                                sx={{
                                                    ...styles.btn,
                                                    backgroundColor: '#FF7916',
                                                    ':hover': {
                                                        backgroundColor:
                                                            '#FF7916',
                                                    },
                                                }}
                                                onClick={() => {
                                                    setOpenModalConfirm(true);
                                                    setStatusToConfirm(
                                                        CampaignConstants.status
                                                            .CLIENT_COMPLETED
                                                    );
                                                    setModalConfirmTitle(
                                                        'Xác nhận kết thúc khảo sát'
                                                    );
                                                    setModalConfirmContent(
                                                        <Box>
                                                            Bạn có chắc muốn kết
                                                            thúc khảo sát{' '}
                                                            <strong>
                                                                “
                                                                {currentCampaign?.campaign ||
                                                                    ''}
                                                                ”
                                                            </strong>{' '}
                                                            này không?
                                                            <br />
                                                            Lưu ý: Khi kết thúc
                                                            khảo sát này sẽ dừng
                                                            thu thập dữ liệu{' '}
                                                            <strong>
                                                                vĩnh viễn
                                                            </strong>
                                                            .
                                                        </Box>
                                                    );
                                                }}
                                            >
                                                Kết thúc khảo sát
                                            </Button>
                                        </>
                                    )}
                                </>
                            )}
                        </Box>
                    </Grid>
                )}
                {tabActive === 1 && (
                    <Grid
                        ref={container}
                        item
                        md={!currentCampaign?.is_unique_link ? 9 : 12}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}
                    >
                        <Grid container alignItems={'center'}>
                            <Grid item md={8}>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 600,
                                        color: colors.main,
                                    }}
                                >
                                    {currentCampaign?.campaign}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                md={4}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <CampaignExportButton
                                    onClick={exportPDFWithMethod}
                                    sx={{
                                        width: '177px',
                                    }}
                                />
                            </Grid>
                            <Grid item md={12} mt={2}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        gap: 2,
                                        mb: 2,
                                    }}
                                >
                                    {[
                                        {
                                            icon: <TotalDataIcon />,
                                            value: answerInfo[0],
                                            label: 'Tổng dữ liệu thu thập',
                                            color: 'var(--color-primary-light-40)',
                                        },
                                        {
                                            icon: <EligibleIcon />,
                                            value: answerInfo[1],
                                            label: 'Đủ điều kiện',
                                            color: '#FFEEE2',
                                        },
                                        {
                                            icon: <DataCollectedForAFeeIcon />,
                                            value: answerInfo[2],
                                            label: 'Dữ liệu thu thập có phí',
                                            color: '#EFFBFF',
                                        },
                                        {
                                            icon: (
                                                <TotalNumberOfParticipantsIcon />
                                            ),
                                            value: answerInfo[3],
                                            label: 'Tổng người tham gia',
                                            color: '#FFEAED',
                                        },
                                    ].map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'left',
                                                padding: '24px',
                                                backgroundColor: item.color,
                                                borderRadius: '35.13px',
                                            }}
                                        >
                                            <Box sx={{ marginBottom: 2 }}>
                                                {item.icon}
                                            </Box>
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: '37.5px',
                                                    color: '#000000B2',
                                                    lineHeight: '44px',
                                                    marginBottom: 1.5,
                                                }}
                                            >
                                                {item.value}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: '25px',
                                                    color: '#000000B2',
                                                    lineHeight: '44px',
                                                }}
                                            >
                                                {item.label}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Grid>
                            <Grid
                                item
                                md={12}
                                mb={2}
                                display="flex"
                                alignItems={'center'}
                            >
                                <Typography component={'p'}>
                                    Hiển thị{' '}
                                    {paginationInfo.currentPage *
                                        paginationInfo.perPage -
                                        paginationInfo.perPage +
                                        1}{' '}
                                    -{' '}
                                    {paginationInfo.currentPage *
                                        paginationInfo.perPage >
                                    paginationInfo.totalItems
                                        ? paginationInfo.totalItems
                                        : paginationInfo.currentPage *
                                          paginationInfo.perPage}{' '}
                                    trên {paginationInfo.totalItems}
                                </Typography>
                                <Pagination
                                    color="primary"
                                    count={paginationInfo.totalPage}
                                    page={paginationInfo.currentPage}
                                    onChange={handleChangePage}
                                />
                            </Grid>
                            <Grid item md={12}>
                                {listAnswerApproved.map(
                                    (item, AnswerApproveIndex) => {
                                        const itemUsername =
                                            item.userName || '';
                                        return (
                                            <React.Fragment
                                                key={AnswerApproveIndex}
                                            >
                                                <Box
                                                    sx={{
                                                        padding:
                                                            '24px 24px 12px 24px',
                                                        display: 'grid',
                                                        gridTemplateColumns:
                                                            '1fr 1fr',
                                                        gap: 1,
                                                        backgroundColor: (
                                                            theme
                                                        ) =>
                                                            theme.palette.common
                                                                .white,
                                                        borderRadius:
                                                            '30px 30px 0 0',
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            gap: 1,
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: '#475EFB',
                                                                fontWeight: 700,
                                                            }}
                                                        >
                                                            {item.user_id}
                                                        </Typography>{' '}
                                                        -
                                                        <Tooltip
                                                            title={itemUsername}
                                                            arrow
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    display:
                                                                        'inline-block',
                                                                    whiteSpace:
                                                                        'nowrap',
                                                                    color: '#000000B2',
                                                                    fontWeight: 700,
                                                                    overflow:
                                                                        'hidden',
                                                                    textOverflow:
                                                                        itemUsername.length >
                                                                        40
                                                                            ? 'ellipsis'
                                                                            : 'unset',
                                                                    width:
                                                                        itemUsername.length >
                                                                        40
                                                                            ? '300px'
                                                                            : 'unset',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                {itemUsername}
                                                            </Typography>
                                                        </Tooltip>
                                                        {renderApprovalStatus(
                                                            item.status
                                                        )}
                                                    </Box>

                                                    <Box
                                                        sx={{
                                                            textAlign: 'right',
                                                            display: 'flex',
                                                            justifyContent:
                                                                'flex-end',
                                                            alignItems:
                                                                'center',
                                                            gap: 1,
                                                        }}
                                                    >
                                                        Tổng phản hồi:{' '}
                                                        {item.totalFeedback}
                                                        <Button
                                                            onClick={() => {
                                                                setAnswerApprove(
                                                                    item
                                                                );
                                                                setOpenModalCensor(
                                                                    true
                                                                );
                                                            }}
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor:
                                                                    colors.main,
                                                                color: common.white,
                                                                borderRadius:
                                                                    '50px',
                                                                textTransform:
                                                                    'none',
                                                                fontSize:
                                                                    '14px',
                                                                fontWeight: 700,
                                                            }}
                                                        >
                                                            Xem chi tiết
                                                        </Button>
                                                    </Box>

                                                    <Box>
                                                        Đã gửi: {item.time} trên
                                                        thiết bị {item.device}
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            textAlign: 'right',
                                                        }}
                                                    >
                                                        Thời gian trung bình:{' '}
                                                        {item.timeAvg}
                                                    </Box>
                                                </Box>

                                                <Divider
                                                    sx={{
                                                        gridColumn: '1 / -1',
                                                        border: 'none',
                                                        borderTop:
                                                            '2px dashed #000',
                                                    }}
                                                />

                                                <Box
                                                    sx={{
                                                        padding:
                                                            '24px 24px 12px 24px',
                                                        backgroundColor: (
                                                            theme
                                                        ) =>
                                                            theme.palette.common
                                                                .white,
                                                        mb: 2,
                                                        borderRadius:
                                                            '0 0 30px 30px',
                                                    }}
                                                >
                                                    {listQuestions.map(
                                                        (
                                                            question: any, // eslint-disable-line @typescript-eslint/no-explicit-any
                                                            questionIndex: number
                                                        ) => (
                                                            <React.Fragment
                                                                key={`${AnswerApproveIndex}-${questionIndex}`}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        display:
                                                                            'grid',
                                                                        gridTemplateColumns:
                                                                            '1fr 1fr',
                                                                        alignItems:
                                                                            'center',
                                                                        mb: 2,
                                                                    }}
                                                                >
                                                                    <Box>
                                                                        Q
                                                                        {
                                                                            question.number
                                                                        }
                                                                        .{' '}
                                                                        {
                                                                            question.title
                                                                        }
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            textAlign:
                                                                                'right',
                                                                        }}
                                                                    >
                                                                        Thời
                                                                        gian trả
                                                                        lời:{' '}
                                                                        {
                                                                            item
                                                                                .answerTime[
                                                                                question
                                                                                    .id
                                                                            ]
                                                                        }{' '}
                                                                        giây
                                                                    </Box>
                                                                </Box>
                                                            </React.Fragment>
                                                        )
                                                    )}
                                                </Box>
                                            </React.Fragment>
                                        );
                                    }
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {tabActive === 0 && currentCampaign?.is_unique_link && (
                    <Grid item xl={12} md={12} xs={12}>
                        <Box
                            sx={{
                                backgroundColor: common.white,
                                padding: 4,
                                minHeight: '450px',
                                width: '100%',
                                borderRadius: '30px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '20px',
                                    gap: 2,
                                }}
                            >
                                <Typography variant="h6" sx={styles.boxTitle}>
                                    Unique Link -{' '}
                                    {currentCampaign?.is_multiple_answer
                                        ? 'Cho phép trả lời nhiều lần'
                                        : 'Chỉ cho phép trả lời một lần'}
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-around',
                                    gap: 2,
                                    mb: 3,
                                }}
                            >
                                {[
                                    {
                                        value: uniqLinkStatistics.total,
                                        label: 'Tổng Unique Link',
                                        color: 'var(--color-primary-light-40)',
                                    },
                                    {
                                        value: uniqLinkStatistics.answered,
                                        label: 'Đã trả lời',
                                        color: '#EFFBFF',
                                    },
                                    {
                                        value: uniqLinkStatistics.not_answered,
                                        label: 'Chưa trả lời',
                                        color: '#FFEEE2',
                                    },
                                ].map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            padding: '20px',
                                            backgroundColor: item.color,
                                            borderRadius: '20px',
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: '28px',
                                                color: '#000000B2',
                                                marginBottom: 1,
                                            }}
                                        >
                                            {item.value}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: '14px',
                                                color: '#000000B2',
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    marginBottom: '24px',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 2,
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{ fontWeight: 500 }}
                                    >
                                        Lọc theo trạng thái:
                                    </Typography>
                                    <Select
                                        value={uniqLinkStatusFilter}
                                        onChange={(e) => {
                                            setUniqLinkStatusFilter(
                                                e.target.value as
                                                    | 'all'
                                                    | 'answered'
                                                    | 'not_answered'
                                            );
                                            setUniqLinksPaginationModel({
                                                page: 0,
                                                pageSize: 10,
                                            });
                                        }}
                                        disabled={loadingUniqLinks}
                                        sx={{
                                            minWidth: 150,
                                            textTransform: 'none',
                                        }}
                                    >
                                        <MenuItem value="all">Tất cả</MenuItem>
                                        <MenuItem value="answered">
                                            Đã trả lời
                                        </MenuItem>
                                        <MenuItem value="not_answered">
                                            Chưa trả lời
                                        </MenuItem>
                                    </Select>
                                </Box>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        startIcon={<RefreshIcon />}
                                        onClick={() => {
                                            fetchAndSetUniqLinksData(
                                                uniqLinksPaginationModel.page
                                            );
                                        }}
                                        sx={{
                                            textTransform: 'none',
                                        }}
                                    >
                                        Làm mới
                                    </Button>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept=".xlsx,.xls,.csv"
                                        style={{ display: 'none' }}
                                        onChange={async (e) => {
                                            const file = e.target.files?.[0];
                                            if (!file) return;

                                            setUploadingUniqLinks(true);
                                            try {
                                                await importUniqLinks(
                                                    Number(campaignId),
                                                    file
                                                );
                                                // Fetch lại uniq links data
                                                await fetchAndSetUniqLinksData(
                                                    0
                                                );
                                                setUniqLinksPaginationModel({
                                                    page: 0,
                                                    pageSize: 10,
                                                });
                                            } catch (error) {
                                                // Error is handled by the service
                                            } finally {
                                                setUploadingUniqLinks(false);
                                                // Reset file input
                                                if (fileInputRef.current) {
                                                    fileInputRef.current.value =
                                                        '';
                                                }
                                            }
                                        }}
                                    />
                                    <Button
                                        variant="contained"
                                        onClick={async () => {
                                            try {
                                                const blob =
                                                    await downloadUniqLinkTemplate(
                                                        Number(campaignId)
                                                    );
                                                const url =
                                                    window.URL.createObjectURL(
                                                        blob
                                                    );
                                                const a =
                                                    document.createElement('a');
                                                a.href = url;
                                                a.download =
                                                    'uniq-link-template.xlsx';
                                                document.body.appendChild(a);
                                                a.click();
                                                window.URL.revokeObjectURL(url);
                                                document.body.removeChild(a);
                                            } catch (error) {
                                                handleError(error);
                                            }
                                        }}
                                        sx={{
                                            textTransform: 'none',
                                        }}
                                    >
                                        Tải Template
                                    </Button>
                                    <Button
                                        variant="contained"
                                        disabled={uploadingUniqLinks}
                                        onClick={() => {
                                            fileInputRef.current?.click();
                                        }}
                                        sx={{
                                            textTransform: 'none',
                                        }}
                                    >
                                        {uploadingUniqLinks
                                            ? 'Đang upload...'
                                            : 'Upload File'}
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={async () => {
                                            try {
                                                const blob =
                                                    await exportUniqLinks(
                                                        Number(campaignId)
                                                    );
                                                const url =
                                                    window.URL.createObjectURL(
                                                        blob
                                                    );
                                                const a =
                                                    document.createElement('a');
                                                a.href = url;
                                                a.download = 'uniq-links.xlsx';
                                                document.body.appendChild(a);
                                                a.click();
                                                window.URL.revokeObjectURL(url);
                                                document.body.removeChild(a);
                                            } catch (error) {
                                                handleError(error);
                                            }
                                        }}
                                        sx={{
                                            textTransform: 'none',
                                        }}
                                    >
                                        Export File
                                    </Button>

                                    {uniqLinkStatistics.not_answered > 0 && (
                                        <Button
                                            variant="contained"
                                            startIcon={<MailIcon />}
                                            disabled={sendingBatchReminder}
                                            onClick={async () => {
                                                try {
                                                    setSendingBatchReminder(
                                                        true
                                                    );
                                                    await sendBatchReminderEmail(
                                                        Number(campaignId),
                                                        selectedUniqLinkIds
                                                    );
                                                    setSelectedUniqLinkIds([]);
                                                } catch (error) {
                                                    // Error is handled by the service
                                                } finally {
                                                    setSendingBatchReminder(
                                                        false
                                                    );
                                                }
                                            }}
                                            sx={{
                                                textTransform: 'none',
                                            }}
                                        >
                                            {sendingBatchReminder
                                                ? 'Đang gửi...'
                                                : 'Gửi email nhắc'}
                                        </Button>
                                    )}
                                </Box>
                            </Box>

                            <BaseDataGrid
                                columns={
                                    [
                                        {
                                            field: 'email',
                                            headerName: 'Email',
                                            flex: 1.2,
                                            renderCell: (params) => (
                                                <Box
                                                    component="div"
                                                    display="flex"
                                                    flexDirection="column"
                                                    justifyContent="center"
                                                    height={'100%'}
                                                >
                                                    <Typography
                                                        component="span"
                                                        fontSize={'14px'}
                                                        lineHeight={'17px'}
                                                    >
                                                        {params.row.email}
                                                    </Typography>
                                                </Box>
                                            ),
                                        },
                                        {
                                            field: 'url_survey',
                                            headerName: 'Link',
                                            flex: 1,
                                            sortable: false,
                                            disableColumnMenu: true,
                                            renderCell: (params) => (
                                                <Box
                                                    component="div"
                                                    display="flex"
                                                    justifyContent="flex-start"
                                                    alignItems="center"
                                                    height={'100%'}
                                                    width={'100%'}
                                                >
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toast.success(
                                                                'Đã sao chép vào clipboard'
                                                            );
                                                            navigator.clipboard.writeText(
                                                                params.row
                                                                    .url_survey
                                                            );
                                                        }}
                                                    >
                                                        <ContentCopyIcon
                                                            sx={{
                                                                fontSize:
                                                                    '16px',
                                                                color: colors.main,
                                                            }}
                                                        />
                                                    </IconButton>
                                                </Box>
                                            ),
                                        },
                                        {
                                            field: 'staff_id',
                                            headerName: 'Mã',
                                            flex: 1,
                                            renderCell: (params) => (
                                                <Box component="div">
                                                    <Typography
                                                        component="span"
                                                        fontSize={'14px'}
                                                        lineHeight={'17px'}
                                                    >
                                                        {params.row.staff_id ||
                                                            '-'}
                                                    </Typography>
                                                </Box>
                                            ),
                                        },
                                        {
                                            field: 'is_answered',
                                            headerName: 'Trạng thái',
                                            flex: 1,
                                            renderCell: (params) => (
                                                <Box component="div">
                                                    <Typography
                                                        component="span"
                                                        fontSize={'14px'}
                                                        lineHeight={'17px'}
                                                        sx={{
                                                            color: params.row
                                                                .is_answered
                                                                ? '#4caf50'
                                                                : '#f44336',
                                                            fontWeight: 'bold',
                                                        }}
                                                    >
                                                        {params.row.is_answered
                                                            ? 'Đã trả lời'
                                                            : 'Chưa trả lời'}
                                                    </Typography>
                                                </Box>
                                            ),
                                        },
                                        {
                                            field: 'created_at',
                                            headerName: 'Ngày tạo',
                                            flex: 1,
                                            renderCell: (params) => (
                                                <Box component="div">
                                                    <Typography
                                                        component="span"
                                                        fontSize={'14px'}
                                                        lineHeight={'17px'}
                                                    >
                                                        {params.row
                                                            .created_at || ''}
                                                    </Typography>
                                                </Box>
                                            ),
                                        },
                                        {
                                            field: 'actions',
                                            headerName: 'Hành động',
                                            flex: 1.2,
                                            sortable: false,
                                            disableColumnMenu: true,
                                            renderCell: (params) => (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        gap: 1,
                                                        justifyContent:
                                                            'flex-start',
                                                        alignItems: 'center',
                                                        height: '100%',
                                                        width: '100%',
                                                    }}
                                                >
                                                    <IconButton
                                                        size="small"
                                                        disabled={
                                                            loadingActionStates[
                                                                params.row.id
                                                            ] === 'edit'
                                                        }
                                                        onClick={() => {
                                                            setSelectedUniqLink(
                                                                params.row
                                                            );
                                                            setEditFormData({
                                                                customer_id:
                                                                    params.row
                                                                        .customer_id,
                                                                email: params
                                                                    .row.email,
                                                                phone: params
                                                                    .row.phone,
                                                            });
                                                            setOpenEditUniqLinkModal(
                                                                true
                                                            );
                                                        }}
                                                        sx={{
                                                            color: 'primary.main',
                                                        }}
                                                    >
                                                        {loadingActionStates[
                                                            params.row.id
                                                        ] === 'edit' ? (
                                                            <CircularProgress
                                                                size={20}
                                                            />
                                                        ) : (
                                                            <EditIcon fontSize="small" />
                                                        )}
                                                    </IconButton>
                                                    <IconButton
                                                        size="small"
                                                        disabled={
                                                            loadingActionStates[
                                                                params.row.id
                                                            ] === 'delete'
                                                        }
                                                        onClick={async () => {
                                                            if (
                                                                !window.confirm(
                                                                    'Bạn chắc chắn muốn xóa?'
                                                                )
                                                            ) {
                                                                return;
                                                            }

                                                            try {
                                                                setLoadingActionStates(
                                                                    (prev) => ({
                                                                        ...prev,
                                                                        [params
                                                                            .row
                                                                            .id]:
                                                                            'delete',
                                                                    })
                                                                );
                                                                await deleteUniqLinkInSurvey(
                                                                    Number(
                                                                        campaignId
                                                                    ),
                                                                    params.row
                                                                        .id
                                                                );
                                                                // Fetch lại dữ liệu
                                                                await fetchAndSetUniqLinksData(
                                                                    uniqLinksPaginationModel.page
                                                                );
                                                            } catch (error) {
                                                                // Error is handled by the service
                                                            } finally {
                                                                setLoadingActionStates(
                                                                    (prev) => ({
                                                                        ...prev,
                                                                        [params
                                                                            .row
                                                                            .id]:
                                                                            null,
                                                                    })
                                                                );
                                                            }
                                                        }}
                                                        sx={{
                                                            color: 'error.main',
                                                        }}
                                                    >
                                                        {loadingActionStates[
                                                            params.row.id
                                                        ] === 'delete' ? (
                                                            <CircularProgress
                                                                size={20}
                                                            />
                                                        ) : (
                                                            <DeleteIcon fontSize="small" />
                                                        )}
                                                    </IconButton>
                                                    <IconButton
                                                        size="small"
                                                        disabled={
                                                            loadingActionStates[
                                                                params.row.id
                                                            ] === 'send'
                                                        }
                                                        onClick={async () => {
                                                            try {
                                                                setLoadingActionStates(
                                                                    (prev) => ({
                                                                        ...prev,
                                                                        [params
                                                                            .row
                                                                            .id]:
                                                                            'send',
                                                                    })
                                                                );
                                                                await sendReminderEmail(
                                                                    Number(
                                                                        campaignId
                                                                    ),
                                                                    params.row
                                                                        .id
                                                                );
                                                            } catch (error) {
                                                                // Error is handled by the service
                                                            } finally {
                                                                setLoadingActionStates(
                                                                    (prev) => ({
                                                                        ...prev,
                                                                        [params
                                                                            .row
                                                                            .id]:
                                                                            null,
                                                                    })
                                                                );
                                                            }
                                                        }}
                                                        sx={{
                                                            color: 'primary.main',
                                                        }}
                                                    >
                                                        {loadingActionStates[
                                                            params.row.id
                                                        ] === 'send' ? (
                                                            <CircularProgress
                                                                size={20}
                                                            />
                                                        ) : (
                                                            <MailIcon fontSize="small" />
                                                        )}
                                                    </IconButton>
                                                </Box>
                                            ),
                                        },
                                    ] as GridColDef[]
                                }
                                rows={uniqLinks}
                                checkboxSelection
                                disableRowSelectionOnClick
                                disableColumnMenu
                                autoHeight
                                sx={styles.dataGrid}
                                rowHeight={83}
                                localeText={{
                                    footerRowSelected: (count) => (
                                        <Typography
                                            component="span"
                                            fontSize={'16px'}
                                        >
                                            {count} hàng đã chọn
                                        </Typography>
                                    ),
                                }}
                                slots={{
                                    pagination: CustomPagination,
                                    noRowsOverlay: () => (
                                        <Box
                                            component="div"
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height={'100%'}
                                        >
                                            <Typography
                                                component="span"
                                                fontSize={'16px'}
                                            >
                                                Không có dữ liệu
                                            </Typography>
                                        </Box>
                                    ),
                                    baseCheckbox: (props) => (
                                        <Checkbox
                                            {...props}
                                            checkedIcon={
                                                <CampaignCheckBoxChecked
                                                    sx={{
                                                        color: (theme) =>
                                                            theme.palette.text
                                                                .primary,
                                                    }}
                                                />
                                            }
                                            icon={<CampaignCheckBoxUnchecked />}
                                            indeterminateIcon={
                                                <IndeterminateCheckBoxIcon
                                                    style={{
                                                        width: '20px',
                                                        height: '20px',
                                                    }}
                                                />
                                            }
                                        />
                                    ),
                                }}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                pageSizeOptions={[]}
                                paginationMode="server"
                                paginationModel={uniqLinksPaginationModel}
                                onPaginationModelChange={(newModel) => {
                                    setUniqLinksPaginationModel(newModel);
                                }}
                                onRowSelectionModelChange={(newSelection) => {
                                    setSelectedUniqLinkIds(
                                        newSelection as number[]
                                    );
                                }}
                                rowSelectionModel={selectedUniqLinkIds}
                                rowCount={uniqLinksRowCount}
                            />
                        </Box>
                    </Grid>
                )}

                {/* TODO */}
                {tabActive === 0 &&
                    currentCampaign?.secure_type === 'secret_once' && (
                        <Grid item xl={12} md={12} xs={12}>
                            <Box
                                sx={{
                                    backgroundColor: common.white,
                                    padding: 4,
                                    minHeight: '450px',
                                    width: '100%',
                                    borderRadius: '30px',
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '20px',
                                        gap: 2,
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={styles.boxTitle}
                                    >
                                        Mã bảo mật 2 lần
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        gap: 2,
                                        mb: 3,
                                    }}
                                >
                                    {[
                                        {
                                            value: secretCodeStatistics.total,
                                            label: 'Tổng Code',
                                            color: 'var(--color-primary-light-40)',
                                        },
                                        {
                                            value: secretCodeStatistics.answered,
                                            label: 'Đã trả lời',
                                            color: '#EFFBFF',
                                        },
                                        {
                                            value: secretCodeStatistics.not_answered,
                                            label: 'Chưa trả lời',
                                            color: '#FFEEE2',
                                        },
                                    ].map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                padding: '20px',
                                                backgroundColor: item.color,
                                                borderRadius: '20px',
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: '28px',
                                                    color: '#000000B2',
                                                    marginBottom: 1,
                                                }}
                                            >
                                                {item.value}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: '14px',
                                                    color: '#000000B2',
                                                }}
                                            >
                                                {item.label}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        marginBottom: '24px',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gap: 2,
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            sx={{ fontWeight: 500 }}
                                        >
                                            Lọc theo trạng thái:
                                        </Typography>
                                        <Select
                                            value={secretCodeStatusFilter}
                                            onChange={(e) => {
                                                setSecretCodeStatusFilter(
                                                    e.target.value as
                                                        | 'all'
                                                        | 'answered'
                                                        | 'not_answered'
                                                );
                                                setSecretCodesPaginationModel({
                                                    page: 0,
                                                    pageSize: 10,
                                                });
                                            }}
                                            disabled={loadingSecretCodes}
                                            sx={{
                                                minWidth: 150,
                                                textTransform: 'none',
                                            }}
                                        >
                                            <MenuItem value="all">
                                                Tất cả
                                            </MenuItem>
                                            <MenuItem value="answered">
                                                Đã trả lời
                                            </MenuItem>
                                            <MenuItem value="not_answered">
                                                Chưa trả lời
                                            </MenuItem>
                                        </Select>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gap: 1,
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                setOpenCreateSecretCodeModal(
                                                    true
                                                );
                                            }}
                                            sx={{
                                                textTransform: 'none',
                                            }}
                                        >
                                            Tạo Code
                                        </Button>

                                        {/* <Button
                                            variant="contained"
                                            onClick={async () => {
                                                try {
                                                    // TODO: Call API to export secret codes not answered
                                                    // const blob = await exportSecretCodes(
                                                    //     Number(campaignId),
                                                    //     'not_answered'
                                                    // );
                                                    // const url = window.URL.createObjectURL(blob);
                                                    // const a = document.createElement('a');
                                                    // a.href = url;
                                                    // a.download = 'secret-codes.xlsx';
                                                    // document.body.appendChild(a);
                                                    // a.click();
                                                    // window.URL.revokeObjectURL(url);
                                                    // document.body.removeChild(a);
                                                } catch (error) {
                                                    handleError(error);
                                                }
                                            }}
                                            sx={{
                                                textTransform: 'none',
                                            }}
                                        >
                                            Tải danh sách code
                                        </Button> */}
                                    </Box>
                                </Box>

                                <BaseDataGrid
                                    columns={
                                        [
                                            {
                                                field: 'code',
                                                headerName: 'Code',
                                                flex: 1.2,
                                                renderCell: (params) => (
                                                    <Box
                                                        component="div"
                                                        display="flex"
                                                        flexDirection="row"
                                                        alignItems="center"
                                                        justifyContent="flex-start"
                                                        gap={1}
                                                        height={'100%'}
                                                    >
                                                        <Typography
                                                            component="span"
                                                            fontSize={'14px'}
                                                            lineHeight={'17px'}
                                                        >
                                                            {params.row.code}
                                                        </Typography>
                                                        <CopyToClipboard
                                                            text={
                                                                params.row.code
                                                            }
                                                            onCopy={() => {
                                                                toast.success(
                                                                    'Đã sao chép code'
                                                                );
                                                            }}
                                                        >
                                                            <IconButton
                                                                size="small"
                                                                sx={{
                                                                    padding: 0,
                                                                }}
                                                            >
                                                                <ContentCopyIcon
                                                                    sx={{
                                                                        fontSize:
                                                                            '16px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </CopyToClipboard>
                                                    </Box>
                                                ),
                                            },
                                            {
                                                field: 'is_answered',
                                                headerName: 'Trạng thái',
                                                flex: 1,
                                                renderCell: (params) => (
                                                    <Box
                                                        component="div"
                                                        display="flex"
                                                        flexDirection="column"
                                                        justifyContent="center"
                                                        height={'100%'}
                                                    >
                                                        <Typography
                                                            component="span"
                                                            fontSize={'14px'}
                                                            lineHeight={'17px'}
                                                            sx={{
                                                                color: params
                                                                    .row.user_id
                                                                    ? '#4caf50'
                                                                    : '#f44336',
                                                                fontWeight:
                                                                    'bold',
                                                            }}
                                                        >
                                                            {params.row.user_id
                                                                ? 'Đã trả lời'
                                                                : 'Chưa trả lời'}
                                                        </Typography>
                                                    </Box>
                                                ),
                                            },
                                            {
                                                field: 'created_at',
                                                headerName: 'Ngày tạo',
                                                flex: 1,
                                                renderCell: (params) => (
                                                    <Box
                                                        component="div"
                                                        display="flex"
                                                        flexDirection="column"
                                                        justifyContent="center"
                                                        height={'100%'}
                                                    >
                                                        <Typography
                                                            component="span"
                                                            fontSize={'14px'}
                                                            lineHeight={'17px'}
                                                        >
                                                            {
                                                                params.row
                                                                    .created_at
                                                            }
                                                        </Typography>
                                                    </Box>
                                                ),
                                            },
                                            /* Tạm ẩn cột Hành động — chưa có API xóa secret code
                                            {
                                                field: 'actions',
                                                headerName: 'Hành động',
                                                flex: 1,
                                                sortable: false,
                                                disableColumnMenu: true,
                                                renderCell: (params) => (
                                                    <Box
                                                        component="div"
                                                        display="flex"
                                                        flexDirection="row"
                                                        gap={1}
                                                        height={'100%'}
                                                        alignItems="center"
                                                    >
                                                        <Tooltip title="Xóa">
                                                            <IconButton
                                                                size="small"
                                                                onClick={async () => {
                                                                    if (
                                                                        !campaignId
                                                                    )
                                                                        return;
                                                                    try {
                                                                        setLoadingActionStatesSecretCode(
                                                                            (
                                                                                prev
                                                                            ) => ({
                                                                                ...prev,
                                                                                [params
                                                                                    .row
                                                                                    .id]:
                                                                                    'delete',
                                                                            })
                                                                        );
                                                                        // TODO: Call API to delete secret code
                                                                        // await deleteSecretCode(params.row.id);
                                                                        await fetchAndSetSecretCodesData(
                                                                            secretCodesPaginationModel.page
                                                                        );
                                                                        toast.success(
                                                                            'Xóa thành công'
                                                                        );
                                                                    } catch (error) {
                                                                        handleError(
                                                                            error
                                                                        );
                                                                    } finally {
                                                                        setLoadingActionStatesSecretCode(
                                                                            (
                                                                                prev
                                                                            ) => ({
                                                                                ...prev,
                                                                                [params
                                                                                    .row
                                                                                    .id]:
                                                                                    null,
                                                                            })
                                                                        );
                                                                    }
                                                                }}
                                                                disabled={
                                                                    loadingActionStatesSecretCode[
                                                                        params
                                                                            .row
                                                                            .id
                                                                    ] ===
                                                                    'delete'
                                                                }
                                                            >
                                                                {loadingActionStatesSecretCode[
                                                                    params.row
                                                                        .id
                                                                ] ===
                                                                'delete' ? (
                                                                    <CircularProgress
                                                                        size={
                                                                            20
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <DeleteIcon
                                                                        sx={{
                                                                            fontSize:
                                                                                '18px',
                                                                        }}
                                                                    />
                                                                )}
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                ),
                                            },
                                            */
                                        ] as GridColDef[]
                                    }
                                    rows={secretCodesData}
                                    disableColumnMenu
                                    autoHeight
                                    sx={styles.dataGrid}
                                    rowHeight={83}
                                    slots={{
                                        pagination: CustomPagination,
                                        noRowsOverlay: () => (
                                            <Box
                                                component="div"
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height={'100%'}
                                            >
                                                <Typography
                                                    component="span"
                                                    fontSize={'16px'}
                                                >
                                                    Không có dữ liệu
                                                </Typography>
                                            </Box>
                                        ),
                                    }}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[]}
                                    paginationMode="server"
                                    paginationModel={secretCodesPaginationModel}
                                    onPaginationModelChange={(newModel) => {
                                        setSecretCodesPaginationModel(newModel);
                                    }}
                                    rowCount={secretCodesRowCount}
                                />
                            </Box>
                        </Grid>
                    )}
            </Grid>

            {openModalCopy && (
                <CampaignModalCopy
                    open={openModalCopy}
                    campaignName={currentCampaign?.campaign || ''}
                    handleClose={() => setOpenModalCopy(false)}
                    handleCopy={() => {
                        onConfirmCopyCampaign();
                        setOpenModalCopy(false);
                    }}
                />
            )}
            {/* dùng chung đóng , mở lại, kết thúc khảo sát */}
            {openModalConfirm && (
                <ModalConfirm
                    open={openModalConfirm}
                    onClose={() => setOpenModalConfirm(false)}
                    onOk={() => {
                        handleUpdateStatus();
                        setOpenModalConfirm(false);
                    }}
                    title={modalConfirmTitle}
                    content={modalConfirmContent}
                />
            )}
            {openModalCensor && (
                <DialogAnswerModeration
                    open={openModalCensor}
                    answerApprove={answerApprove}
                    onClose={() => setOpenModalCensor(false)}
                    onChangeAnswerApprovedStatus={changeAnswerApprovedStatus}
                    listQuestions={listQuestions}
                />
            )}
            <Dialog
                open={openEditUniqLinkModal}
                onClose={() => {
                    setOpenEditUniqLinkModal(false);
                    setSelectedUniqLink(null);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Cập nhật Unique Link</DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <TextField
                        fullWidth
                        label="Mã khách hàng"
                        value={editFormData.customer_id}
                        onChange={(e) =>
                            setEditFormData({
                                ...editFormData,
                                customer_id: e.target.value,
                            })
                        }
                        margin="normal"
                    />
                    <TextField
                        fullWidth
                        label="Email"
                        type="email"
                        value={editFormData.email}
                        onChange={(e) =>
                            setEditFormData({
                                ...editFormData,
                                email: e.target.value,
                            })
                        }
                        margin="normal"
                    />
                    <TextField
                        fullWidth
                        label="Số điện thoại"
                        value={editFormData.phone}
                        onChange={(e) =>
                            setEditFormData({
                                ...editFormData,
                                phone: e.target.value,
                            })
                        }
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={() => {
                            setOpenEditUniqLinkModal(false);
                            setSelectedUniqLink(null);
                        }}
                    >
                        Hủy
                    </Button>
                    <Button
                        variant="contained"
                        disabled={updatingUniqLink}
                        onClick={async () => {
                            if (!selectedUniqLink || !campaignId) return;

                            setUpdatingUniqLink(true);
                            try {
                                await updateUniqLinkInSurvey(
                                    Number(campaignId),
                                    selectedUniqLink.id,
                                    {
                                        customer_id: editFormData.customer_id,
                                        email: editFormData.email,
                                        phone: editFormData.phone,
                                    }
                                );
                                setOpenEditUniqLinkModal(false);
                                setSelectedUniqLink(null);
                                // Fetch lại dữ liệu
                                await fetchAndSetUniqLinksData(
                                    uniqLinksPaginationModel.page
                                );
                            } catch (error) {
                                // Error is handled by the service
                            } finally {
                                setUpdatingUniqLink(false);
                            }
                        }}
                    >
                        {updatingUniqLink ? 'Đang lưu...' : 'Lưu'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openCreateSecretCodeModal}
                onClose={() => {
                    setOpenCreateSecretCodeModal(false);
                    setCreateSecretCodeForm({ quantity: '' });
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 600, fontSize: '18px' }}>
                    Nhập số lượng mã muốn tạo (1-10000)
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ pt: 2 }}>
                        <BaseNumberInput
                            min={1}
                            max={10000}
                            fullWidth
                            value={createSecretCodeForm.quantity}
                            onChange={(v) =>
                                setCreateSecretCodeForm({
                                    ...createSecretCodeForm,
                                    quantity: v,
                                })
                            }
                            placeholder="Nhập số lượng code"
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={() => {
                            setOpenCreateSecretCodeModal(false);
                            setCreateSecretCodeForm({ quantity: '' });
                        }}
                    >
                        Hủy
                    </Button>
                    <Button
                        variant="contained"
                        disabled={
                            createSecretCodeLoading ||
                            !createSecretCodeForm.quantity
                        }
                        onClick={async () => {
                            if (!campaignId) return;

                            setCreateSecretCodeLoading(true);
                            try {
                                const quantity = parseInt(
                                    createSecretCodeForm.quantity
                                );
                                if (isNaN(quantity) || quantity < 1) {
                                    toast.error(
                                        'Vui lòng nhập số lượng hợp lệ'
                                    );
                                    return;
                                }

                                // TODO: Call API to create secret codes
                                await createSecretCodes(
                                    Number(campaignId),
                                    quantity
                                );
                                setOpenCreateSecretCodeModal(false);
                                setCreateSecretCodeForm({ quantity: '' });
                                // Reset pagination sẽ kích hoạt useEffect để fetch lại dữ liệu
                                setSecretCodesPaginationModel({
                                    page: 0,
                                    pageSize: 10,
                                });
                            } catch (error) {
                                handleError(error);
                            } finally {
                                setCreateSecretCodeLoading(false);
                            }
                        }}
                    >
                        {createSecretCodeLoading ? 'Đang tạo...' : 'Tạo'}
                    </Button>
                </DialogActions>
            </Dialog>
        </CampaignContainer>
    );
};
const styles = createStyleSheet({
    btn: {
        borderRadius: '50px',
        height: '60px',
        width: '100%',
        marginTop: '20px',
        fontSize: '20px',
        textTransform: 'none',
        fontWeight: 600,
        lineHeight: '24.2px',
    },
    boxTitle: {
        fontWeight: 'bold',
        fontSize: '22px',
    },
    dataGrid: {
        '--DataGrid-rowBorderColor': 'transparent',
        '.MuiDataGrid-columnHeaders': {
            height: '83px',
            justifyContent: 'center',
        },
        '.MuiDataGrid-columnHeader': {
            padding: 0,
        },
        '.MuiDataGrid-columnHeaderTitle': {
            fontSize: '20px',
            lineHeight: '24px',
            fontWeight: 700,
        },
        '.MuiDataGrid-columnHeaderTitleContainer': {
            display: 'flex',
        },
        '.MuiDataGrid-cell': {
            outline: 'none !important',
            padding: '0',
        },
        '.MuiDataGrid-footerContainer': {
            borderColor: 'transparent',
            marginBottom: '44px',
            marginRight: '54px',
        },
        '.MuiTablePagination-displayedRows': {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '17px',
        },
        border: 'none',
    },
});
export default SurveyActive;
